import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { AdminAuthService } from '../../services/admin-auth.service';

@Component({
  selector: 'app-admin-access-denied',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './admin-access-denied.component.html',
  styleUrl: './admin-access-denied.component.css'
})
export class AdminAccessDeniedComponent implements OnInit {
  message = 'Admin sign-in is required to access this area.';

  constructor(private readonly adminAuth: AdminAuthService) {}

  ngOnInit(): void {
    this.message =
      this.adminAuth.accessDeniedMessage ??
      'Admin sign-in is required to access this area.';
  }
}
